// extracted by mini-css-extract-plugin
module.exports = {"Breadcrumb":"Breadcrumb_Breadcrumb__3lyTx"};